<template>

  <div id="app">

      <!--ВРЕМЕННО-->
      <b-navbar toggleable="md" type="dark" variant="info">

          <b-collapse is-nav id="nav_collapse">
              <b-navbar-brand href="/run.html">FoldGO</b-navbar-brand>
              <!-- Right aligned nav items -->
              <b-navbar-nav class="ml-auto">
                  <b-nav-item href="/help.html">Help</b-nav-item>
                  <b-nav-item href="/">About</b-nav-item>
              </b-navbar-nav>

          </b-collapse>
      </b-navbar>
      <!--КОНЕЦ ВРЕМЕННОГО-->
      <b-alert variant="danger"
               dismissible
               :show="showDismissibleAlert"
               @dismissed="showDismissibleAlert=false">
          {{this.error}}
      </b-alert>
      <b-jumbotron>
        <template slot="header">
            <img src="files/foldgo_logo_by.svg"/>
        </template>
        <template slot="lead">
        <b-container>
            <b-row>
                <b-col>
                        <p>FoldGO is a web tool for fold-change-specific functional enrichment analysis of transcriptome. FoldGO identifies 
                        gene ontology (GO) terms specifically enriched in sets of genes with a similar fold-changes in response to a stimulus</p>
                </b-col>
            </b-row>
        </b-container>
        </template>
      </b-jumbotron>
    <b-container>


        <b-row align-v="center">
            <b-col></b-col>
        </b-row>
        <b-row align-v="center">
            <b-col ><label>Up-regulated genes</label></b-col>
            <!-- <b-col><b-button-group>
                    <b-button  @click="click('up')" class="with-margin" variant="primary">Load file</b-button>
                </b-button-group>
            </b-col>

            <input id="up" type="file" v-on:change="fileLoad('fileUp', $event)" hidden/>
            <b-col>{{fileUpText}}</b-col> -->
            <b-col cols=8>
                <div class="input-group mb-3">
                    <div class="custom-file">
                        <input type="file" class="custom-file-input" id="up" v-on:change="fileLoad('fileUp', $event)">
                        <label class="custom-file-label" for="up">{{fileUpText}}</label>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row align-v="center">
            <b-col><label>Down-regulated genes </label></b-col>
            <!-- <b-col><b-button-group>
                <b-button  @click="click('down')" class="with-margin" variant="primary">Load file</b-button>
            </b-button-group></b-col>
            <input type="file" id="down" v-on:change="fileLoad('fileDown', $event)" hidden/>
            <b-col>{{fileDownText}}</b-col> -->
            <b-col cols=8>
                <div class="input-group mb-3">
                    <div class="custom-file">
                        <input type="file" class="custom-file-input" id="down" v-on:change="fileLoad('fileDown', $event)">
                        <label class="custom-file-label" for="down">{{fileDownText}}</label>
                    </div>
                </div>
            </b-col>
        </b-row>

        <b-row align-v="center">
            <b-col><label>Background genes<br>
            (Optional) </label></b-col>
            <!-- <b-col><b-button-group>
                <b-button  @click="click('down')" class="with-margin" variant="primary">Load file</b-button>
            </b-button-group></b-col>
            <input type="file" id="down" v-on:change="fileLoad('fileDown', $event)" hidden/>
            <b-col>{{fileDownText}}</b-col> -->
            <b-col cols=8>
                <div class="input-group mb-3">
                    <div class="custom-file">
                        <input type="file" class="custom-file-input" id="all" v-on:change="fileLoad('fileAll', $event)">
                        <label class="custom-file-label" for="all">{{fileAllText}}</label>
                    </div>
                </div>
            </b-col>

        </b-row>
        <b-row>
            <b-col><label>Organism</label></b-col>
            <b-col cols="8">
                <b-form-select v-model="params.organismName" :options="organism_list" style="font-style: italic"></b-form-select>
            </b-col>
        </b-row>

    </b-container>

      <b-container sm="auto">
          <b-row align-h="center">
              <b-col ></b-col>
              <b-col></b-col>
              <Parameters v-bind:params="params" v-bind:default_params="default_params" v-on:on_reset="params = Object.assign({}, default_params)" align-v="center"/>
          </b-row>
          <b-row>
              <b-col>
                  <b-button @click="loadExample('fileUp')" size="lg" variant="primary" :block=true>
                      Load example
                  </b-button>
              </b-col>
              <b-col>
                  <b-button  align-v="center" @click="clear" size="lg" variant="primary" :block=true>
                      Clear
                  </b-button>
              </b-col>
              <b-col>
                  <b-button align-v="center" @click="run" size="lg" variant="outline-success" :block=true :disabled="load_results">
                      Run
                  </b-button>
              </b-col>
          </b-row>
      </b-container>
      <div class="with-margin"/>
      <div class="loader" v-if="load_results"/>
      <div class="with-margin" v-if="load_results"/>

      <b-container v-if="have_result">
          <b-row>
              <b-col><h2>Results</h2><div class="with-margin"/></b-col>
          </b-row>
        <b-nav fill tabs class="with-margin">
            <b-nav-item :active="active_page === 'diagram'" @click="activate_page('diagram')">Fold-change-specific GO profile</b-nav-item>
            <b-nav-item :active="active_page === 'graph'" @click="activate_page('graph')">Graphs</b-nav-item>
            <b-nav-item :active="active_page === 'table'" @click="activate_page('table')">Tables</b-nav-item>
        </b-nav>

        <div v-if="svg_file !== null && active_page === 'diagram'">
            <b-nav fill tabs>
                <b-nav-item :active="index_svg === 0" @click="index_svg = 0">Molecular Function</b-nav-item>
                <b-nav-item :active="index_svg === 1" @click="index_svg = 1">Biological Process</b-nav-item>
                <b-nav-item :active="index_svg === 2" @click="index_svg = 2">Cellular Component</b-nav-item>
            </b-nav>
            <b-row align-v="center"><b-col><div v-html="legend_file[index_svg]" ></div></b-col></b-row>
            <b-row align-v="center"><b-col><div v-html="svg_file[index_svg]" ></div></b-col></b-row>
            <b-row align-v="center"><b-col><b-button v-on:click="download">Download diagram (SVG)</b-button></b-col></b-row>
        </div>
        <div v-if="(graph_file !== null && active_page === 'graph')">
            <b-nav fill tabs>
                <b-nav-item :active="regulated_num === 0" @click="regulated_num = 0">Up-regulated</b-nav-item>
                <b-nav-item :active="regulated_num === 1" @click="regulated_num = 1">Down-regulated</b-nav-item>
            </b-nav>
            <b-nav fill tabs>
                <b-nav-item :active="index_svg === 0" @click="index_svg = 0">Molecular Function</b-nav-item>
                <b-nav-item :active="index_svg === 1" @click="index_svg = 1">Biological Process</b-nav-item>
                <b-nav-item :active="index_svg === 2" @click="index_svg = 2">Cellular Component</b-nav-item>
            </b-nav>


            <b-row align-v="center"><b-col>
                <div class="h_iframe">
                    <iframe frameborder="0" marginwidth="0" marginheight="0" v-bind:srcdoc="window.atob(graph_file[regulated_num][index_svg])" height="600"></iframe>
                </div>
            </b-col></b-row>
            <b-row align-v="center"><b-col><b-button v-on:click="download">Download graph (HTML)</b-button></b-col></b-row>
        </div>

          <div v-if="tables !== null && active_page === 'table'">
              <b-nav fill tabs>
                  <b-nav-item :active="regulated_num === 0" @click="regulated_num = 0">Up-regulated</b-nav-item>
                  <b-nav-item :active="regulated_num === 1" @click="regulated_num = 1">Down-regulated</b-nav-item>
              </b-nav>
              <b-nav fill tabs>
                  <b-nav-item :active="index_table === 0" @click="index_table = 0">Fold-change-specific GO terms</b-nav-item>
                  <b-nav-item :active="index_table === 1" @click="index_table = 1">Not Fold-change-specific GO terms</b-nav-item>
              </b-nav>
              <b-row align-v="center"><b-col><table v-bind:class="[this.index_table === 0 ? 'tUp' : 'tDown', 'display']">
                  <thead>
                  <tr>
                      <th rowspan="2">Ids</th>
                      <th rowspan="2">Namespace</th>
                      <th rowspan="2">Name</th>
                      <th rowspan="2">Interval (fold change)</th>
                      <th colspan="2">DEG GO enrichment stats</th>
                      <th colspan="2">Fold-change-specific enrichment stats</th>
                  </tr>
                  <tr>
                      <th>P-value</th>
                      <th>Q-value</th>
                      <th>P-value</th>
                      <th>Q-value</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="row in tables[regulated_num][index_table]" :key="row">
                      <td v-for="key in columns" :key="key">
                          <p v-if="(key === 'interval' && index_table === 1) " >NA</p>
                          <p v-else>{{row[key]}}</p>
                      </td>
                  </tr>
                  </tbody>
              </table></b-col></b-row>
              <b-row v-if="regulated_num === 0" align-v="center"><b-col><b-button v-on:click="download">Download up-regulated table (CSV)</b-button></b-col></b-row>
              <b-row v-if="regulated_num === 1" align-v="center"><b-col><b-button v-on:click="download">Download down-regulated table (CSV)</b-button></b-col></b-row></div>
    </b-container>

</div>
</template>

<script>
    import $ from 'jquery';
    import 'datatables.net';
    import 'datatables.net-dt/css/jquery.dataTables.css'
    import swal from 'sweetalert'
    import Parameters from './components/Parameters.vue'
    import NetworkService from './components/NetworkService'


    const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;
    const not_file = "No file";
    const loaded_file = "File loaded";
    const example_loaded = "Example loaded";


    export default {

        components:{
            Parameters
        },
        name: 'app',
  data () {
        return {
            msg: 'FoldGO',
            window: window,
            columns: ["ids", "namespace", "name", "interval", "wholepval", "wholepadj", "pval", "padj"],
            columnName:
                {
                    "ids": "Ids",
                    "namespace": "Namespace",
                    "name": "Name",
                    "interval": "Interval (fold change)",
                    "wholepval": "Whole interval\nP-value",
                    "wholepadj": "Whole interval\nQ-value",
                    "pval": "P-Value",
                    "padj": "Q-Value"
                },
            fileUp: null,
            fileDown: null,
            fileAll: null,
            currentStatus: null,
            fileUpText: not_file,
            fileDownText: not_file,
            fileAllText: not_file,
            error: '',
            uploadFieldName: "ALALALA",
            index_svg: 0,
            index_table: 0,
            svg_file: null,
            legend_file: null,
            graph_file: null,
            regulated_num: 0,
            graph_down_file: null,
            tableUp: null,
            tableDown: null,
            tableUpNfc: null,
            tableDownNfc: null,
            tables: null,
            load_results: false,
            have_result: false,
            dismissSecs: 10,
            dismissCountDown: 0,
            showDismissibleAlert: false,
            active_page: 'diagram',
            enable_example: false,
            params: {
                p_value1: 1,
                p_value2: 0.05,
                correction_1: "BH",
                correction_2: "BH",
                min_genes: 1,
                quantiles: 6,
                organismName: 'AT',
                enable_example: false
            },
            default_params: {
                p_value1: 1,
                p_value2: 0.05,
                correction_1: "BH",
                correction_2: "BH",
                min_genes: 1,
                quantiles: 6
            },
            organism_list: [
                {value: "AT", text: "Arabidopsis thaliana - TAIR", style: "font-style: italic" },
                {value: "DP", text:"Drosophila melanogaster - Entrez"},
                {value: "HS", text: "Homo sapiens - Entrez"},
                {value: "HS_ENS", text: "Homo sapiens - Ensemble"},
                {value: "MM", text: "Mus musculus - Entrez"},
                {value: "CE", text: "Caenorhabditis elegans - Entrez"}
            ],
            organism_current: "AT",
            networkService: new NetworkService(this)

        }
    },
    computed: {
      isInitial() {
        return this.currentStatus === STATUS_INITIAL;
      },
      isSaving() {
        return this.currentStatus === STATUS_SAVING;
      },
      isSuccess() {
        return this.currentStatus === STATUS_SUCCESS;
      },
      isFailed() {
        return this.currentStatus === STATUS_FAILED;
      }
    },

        mounted: async function () {
            this.tUphandle = $(".tUp").DataTable({
                "scrollX":  true,
                "scrollY":        "2500px",
                "scrollCollapse": true,
                "paging":         false,
                "ordering": true,
                columnDefs: [
                    { width: 150, targets: 3 }
                ],
                "language": {
                    "emptyTable": "No fold-specific terms available in table"
                },
                // "order":        [[5, "desc"]]
            });
            this.dDownhandle = $(".tDown").DataTable(
                {
                    "scrollX": true,
                    "scrollY":        "2500px",
                    "scrollCollapse": true,
                    "paging":         false,
                    "ordering": true,
                    columnDefs: [
                        { width: 150, targets: 3 }
                    ],
                    "language": {
                        "emptyTable": "No fold-specific terms available in table"
                    },
                    // "order":        [[5, "asc"]]
                }
            );
            if (localStorage.getItem("token"))
            {
                this.load_results = true;
                this.networkService.token = localStorage.getItem("token");
                while (this.load_results){

                        await this.networkService.get();
                        await new Promise(m => setTimeout(m));
                    }
            }
        },

        beforeUpdate: function () {
            this.tUphandle.destroy();
            this.dDownhandle.destroy();
        },
        updated: function () {
            this.tUphandle = $(".tUp").DataTable({
                "scrollX": true,
                "scrollY":        "2500px",
                "scrollCollapse": true,
                "paging":         false,
                "ordering": true,
                columnDefs: [
                    { width: 150, targets: 3 }
                ],
                "language": {
                        "emptyTable": "No fold-change-specific GO terms found"
                },
                // "order":        [[5, "desc"]]
            });
            this.dDownhandle = $(".tDown").DataTable({
                "scrollX": true,
                "scrollY":        "2500px",
                "scrollCollapse": true,
                "paging":         false,
                "ordering": true,
                columnDefs: [
                    { width: 150, targets: 3 }
                ],
                "language": {
                        "emptyTable": "No fold-change-specific GO terms found"
                },
                // "order":        [[5, "asc"]]
            });
        },
        
        methods: {
            download: function (event) {
                let saveData = (function () {
                    let a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    return function (data, fileName, type) {
                        let blob = new Blob([data], {type: type}),
                            url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = fileName;
                        a.click();
                        window.URL.revokeObjectURL(url);
                        // document.body.removeChild(a); // Чтобы не загрязнялася HTML страничка
                    };
                }());
                if (this.active_page === 'diagram')
                {
                    saveData(this.svg_file[this.index_svg], 'diagram.svg', 'image/svg+xml')
                }
                else if (this.active_page === 'graph')
                {
                    let byteCharacters = atob(this.graph_file[this.regulated_num][this.index_svg]);
                    let byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    let byteArray = new Uint8Array(byteNumbers);
                    saveData(byteArray, 'graph.html', 'text/html');
                }
                else if (this.active_page === 'table') {
                    const json2csv = require('json2csv').parse;
                    const csv = json2csv(this.tables[this.regulated_num][this.index_table], this.columns);
                    if (this.regulated_num === 0) {
                        if (this.index_table === 0) {
                            saveData(csv, 'file_up_fc.csv', 'text/csv');
                        }
                        else if (this.index_table === 1) {
                            saveData(csv, 'file_up_nfc.csv', 'text/csv');
                        }

                    }
                    else if (this.regulated_num === 1) {
                        if (this.index_table === 0) {
                            saveData(csv, 'file_down_fc.csv', 'text/csv');
                        }
                        else if (this.index_table === 1) {
                            saveData(csv, 'file_down_nfc.csv', 'text/csv');
                        }
                    }
                }
                else
                {
                    swal("Oops!", "Internal problem with downloading", "error")
                }
            },
            activate_page: function (e) {
                this.active_page = e;
            },
            fileLoad : function (s, event) {
                this[s] = event.target.files[0];
                this[s + 'Text'] = loaded_file;
            },
            click: function (e) {
                document.getElementById(e).click();
            },
            loadExample: function () {
                let arr = ['fileUp', 'fileDown', 'fileAll'];
                for (let e in arr)
                {
                    let blob = null;
                    let request = new XMLHttpRequest();
                    let text = arr[e] + "Example.csv";
                    request.open("GET", text);
                    request.responseType = "blob";
                    request.onload = function () {
                        blob = request.response;
                        if (request.status === 200)
                        {
                            this[arr[e]] = blob;
                            this[arr[e] + 'Text'] = example_loaded;
                            this.params.enable_example = true;
                        }
                    }.bind(this);
                    request.send();
                }
            },
            run: function () {
                this.networkService.upload().then(async () => {
                    while (this.load_results){

                        await this.networkService.get();
                        await new Promise(m => setTimeout(m));
                    }
                });

            },
            clear: function () {
                this.fileUp =  null;
                this.fileDown = null;
                this.fileAll = null;
                this.fileUpText = not_file;
                this.fileDownText = not_file;
                this.fileAllText = not_file;
                this.svg_file = null;
                this.graph_file = null;
                this.tableUp = null;
                this.tableDown = null;
                this.have_result = false;
                this.index_svg = 0;
                this.index_table = 0;
                this.load_results = false;
                this.networkService.token = false;
                this.params.enable_example = false;
                this.tables = null;
            }
  }
}
</script>

<style scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
}


.custom-file-input:lang(en) ~ .custom-file-label::after
{
    content: "Upload"
}

.jumbotron {
    padding: 1rem 2rem;
}

h1, h2 {
  font-weight: normal;
}



ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.with-margin {
  margin-bottom: 20px;
}

.loader {
    border: 16px solid #f3f3f3; /* Light grey */
    border-top: 16px solid #3498db; /* Blue */
    border-radius: 50%;
    width: 120px;
    height: 120px;
    animation: spin 2s linear infinite;
    margin: auto;
    align-content: center;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}


.h_iframe iframe {
    width:100%;
    /*height:100%;*/
}
.h_iframe {
    /*height: 100%;*/
    width:100%;
}

</style>



// WEBPACK FOOTER //
// src/App.vue